import { StateService } from '@/core/services/state.service';
import { Component } from '@angular/core';

@Component({
  selector: 'prozess-navigation',
  templateUrl: './prozess-navigation.component.html',
  styleUrls: ['./prozess-navigation.component.scss']
})
export class ProzessNavigationComponent {
  public get showProzessNavigation(): boolean {
    return this.stateService.showProzessNavigation;
  }
  
  constructor(protected stateService: StateService) { }

  onToggleClick() {
    this.stateService.ToggleProzessNavigation();
  }
}
